"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { TRPCReactProvider } from "@/trpc/react";
import { NavigationProgress } from "@/components/navigation-progress";
export const Providers = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={null}><NavigationProgress /></Suspense>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <TRPCReactProvider>{t1}{children}</TRPCReactProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};